export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const SET_SUCESS_MESSAGE = "SET_SUCESS_MESSAGE";
export const CLEAR_SUCESS_MESSAGE = "CLEAR_SUCESS_MESSAGE";

export const GENERATE_URL_SUCCESS = "GENERATE_URL_SUCCESS";
export const GENERATE_URL_FAIL = "GENERATE_URL_FAIL";